function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

import URI from 'urijs';

var compact = function compact(input) {
  return Object.entries(input).filter(function (_ref) {
    var key = _ref[0],
        value = _ref[1];
    return !!value;
  }).reduce(function (acc, _ref2) {
    var _Object$assign;

    var key = _ref2[0],
        value = _ref2[1];
    return Object.assign(acc, (_Object$assign = {}, _Object$assign[key] = value, _Object$assign));
  }, {});
};
/**
* @param {Object} oath2Redirect
* @param {string} oath2Redirect.domain Set to rails_app domain (required)
* @param {string} oath2Redirect.provider Set to provider name (required)
* @param {string} oath2Redirect.redirectUrl Set to the redirect url after oauth completes (required)
* @param {string} oath2Redirect.idToken Set to pass in an id token (used for cordova flow)
* @param {string} oath2Redirect.prompt Set to 'select_account' to force oauth to select account every time
* @param {string} oath2Redirect.provisioning Set to 'none' to disable account creation
* @param {string} oath2Redirect.role Set to 'participant' to sign up as participant (defaults to presenter if not included)
* @param {string} oath2Redirect.userSourceName Set to the user source name (see rails_app user_sources.yml for list)
* @param {string} oath2Redirect.tokenRequired Set to 'true' to call back with a pe_auth_token after login
* @param {string} oath2Redirect.platform Set to pass in the platform for mapping to OAuth client ID
* @param {string} oath2Redirect.firstName Set to the users firstName (if known) so we can prefill when signing up
* @param {string} oath2Redirect.lastName Set to the users lastName (if known) so we can prefill when signing up
*/


var Oauth2Redirect = /*#__PURE__*/function () {
  function Oauth2Redirect() {
    this.idToken = null;
    this.prompt = null;
    this.provider = null;
    this.provisioning = null;
    this.redirectUrl = null;
    this.role = null;
    this.userSourceName = null;
    this.tokenRequired = null;
    this.platform = null;
    this.firstName = null;
    this.lastName = null;
  }

  _createClass(Oauth2Redirect, [{
    key: "errors",
    get: function get() {
      var _this = this;

      var requiredFields = ['domain', 'provider', 'redirectUrl', 'platform'];
      return requiredFields.filter(function (field) {
        return !_this[field];
      }).map(function (field) {
        return "this." + field + " is required";
      });
    }
  }, {
    key: "url",
    get: function get() {
      if (this.errors.length) {
        return null;
      }

      return URI(this.domain).directory("/oauth2/" + this.provider + "/redirect").query(compact({
        id_token: this.idToken,
        prompt: this.prompt,
        provisioning: this.provisioning,
        redirect: this.redirectUrl,
        role: this.role,
        usrc: this.userSourceName,
        token_required: this.tokenRequired,
        platform: this.platform,
        first_name: this.firstName,
        last_name: this.lastName
      })).toString();
    }
  }]);

  return Oauth2Redirect;
}();

export { Oauth2Redirect as default };